import { Button, Modal, Select } from "antd";
import * as ewcms from "../screen/EWCMS/styleMaster";

const defaultBtnStyle = ewcms.defaultBtnStyle;
const greyBtnStyle = ewcms.greyBtnStyle;

const ChooseClaimModal = (props: any) => {
    const {isChooseClaim, setIsChooseClaim, claimOptions, selectClaimPK, setSelectClaimPK, onConfirmSubmit} = props;
    return (
        <Modal
            open={isChooseClaim}
            onCancel={() => setIsChooseClaim(false)}
            footer={null}
            >
            <div style={{margin: '15px 0 10px 0'}}>Please select the rejected payment request below for amendment:</div>
            <Select
            options={claimOptions}
            value={selectClaimPK}
            onChange={(value) => setSelectClaimPK(value)}
            style={{marginBottom : '15px'}}
            />
            <div className="cust-spacebetween" style={{ justifyContent: "flex-end" }}>
            <Button
                className={greyBtnStyle + " cust-button-height"}
                style={{ marginRight: "10px" }}
                onClick={() => setIsChooseClaim(false)}
            >
                Close
            </Button>
            <Button
                className={defaultBtnStyle + " cust-button-height"}
                onClick={onConfirmSubmit}
            >
                Amend
            </Button>
            </div>
        </Modal>
    );
}

export default ChooseClaimModal;